module.exports = __webpack_public_path__ + "static/media/lo5d_post_D.d03ea04d.svg";